// Konfiguration (Cent)
const GIFT1_TH = 4000;  // Geschenk 1 ab 40 €
const FREE_TH  = 6000;  // Gratis Versand ab 60 €
const GIFT2_TH = 8000;  // Geschenk 2 ab 80 €
const FULL_TH  = 10000; // Balken voll bei 100 €

// Einfaches Ein-/Ausschalten der Aktionen:
const GIFT1_ENABLED = false;
const FREE_ENABLED  = true;
const GIFT2_ENABLED = false;

// SKUs, die nicht zählen sollen / Modul ausblenden
const SPECIAL_SKUS = ['801400', '858500'];

// Cache für /cart.js – vermeidet unnötige Fetches
let _cartCache = null;
let _cartCacheTime = 0;
const CACHE_TTL = 800; // ms

async function getCart() {
  const now = Date.now();
  if (_cartCache && (now - _cartCacheTime) < CACHE_TTL) return _cartCache;
  _cartCache = await fetch('/cart.js', { cache: 'no-cache' }).then(r => r.json());
  _cartCacheTime = now;
  return _cartCache;
}

// Invalidate cache when cart changes
function invalidateCartCache() {
  _cartCache = null;
  _cartCacheTime = 0;
}

async function updateProgress() {
  try {
    const cart   = await getCart();
    const module = document.getElementById('free-shipping-module');
    if (!module) return;

    // Marker-Sichtbarkeit immer neu setzen (Element kann nach Section-Rerender frisch sein)
    const gift1Marker = module.querySelector('.marker.gift1');
    const freeMarker  = module.querySelector('.marker.free');
    const gift2Marker = module.querySelector('.marker.gift2');

    if (GIFT1_ENABLED && gift1Marker) gift1Marker.style.display = 'flex';
    if (FREE_ENABLED  && freeMarker)  freeMarker.style.display  = 'flex';
    if (GIFT2_ENABLED && gift2Marker) gift2Marker.style.display = 'flex';

    // ADVK im Warenkorb? → Modul ausblenden
    const hasSpecialSku = cart.items.some(item => SPECIAL_SKUS.includes(item.sku));
    if (hasSpecialSku) {
      module.style.display = 'none';
      return;
    }
    module.style.display = '';

    // Warenkorb-Wert ohne SPECIAL_SKUS
    const total = cart.items
      .filter(item => !SPECIAL_SKUS.includes(item.sku))
      .reduce((sum, item) => sum + item.line_price, 0);

    const textEl = document.getElementById('shipping-progress-text');
    const fillEl = document.getElementById('progress-bar-fill');
    if (!textEl || !fillEl) return;

    // Fortschrittsbalken (voll bei 100 €)
    const pct = Math.min(100, (total / FULL_TH) * 100);
    fillEl.style.width = `${pct}%`;

    // Marker ggf. ausblenden
    module.classList.toggle('gift1-hidden', !GIFT1_ENABLED);
    module.classList.toggle('free-hidden',  !FREE_ENABLED);
    module.classList.toggle('gift2-hidden', !GIFT2_ENABLED);

    // Restbeträge
    const remainingG1 = GIFT1_TH - total;
    const remainingF  = FREE_TH  - total;
    const remainingG2 = GIFT2_TH - total;

    // ---------- Textlogik ----------

    // Geschenk 2 erreicht
    if (GIFT2_ENABLED && total >= GIFT2_TH) {
      if (FREE_ENABLED) {
        if (GIFT1_ENABLED) {
          textEl.textContent = 'Yay! Je hebt gratis verzending én cadeau 1 & 2! 🎉';
        } else {
          textEl.textContent = 'Yay! Je hebt gratis verzending én een cadeau! 🎉';
        }
      } else {
        textEl.textContent = 'Yay! Je hebt cadeau 1 & 2! 🎉';
      }
      return;
    }

    // Geschenk 2 noch nicht erreicht, aber Gratis Versand schon
    if (FREE_ENABLED && total >= FREE_TH) {
      if (GIFT2_ENABLED) {
        const amt = (remainingG2 / 100).toFixed(2).replace('.', ',');
        if (GIFT1_ENABLED) {
          textEl.textContent = `Gratis verzending ✅ – nog maar ${amt} € tot je 2e cadeau! 🎁`;
        } else {
          textEl.textContent = `Gratis verzending ✅ – nog maar ${amt} € tot je cadeau! 🎁`;
        }
      } else {
        textEl.textContent = 'Yay! Je hebt gratis verzending!';
      }
      return;
    }

    // Gratis Versand noch nicht erreicht, aber Geschenk 1 schon
    if (GIFT1_ENABLED && total >= GIFT1_TH) {
      if (FREE_ENABLED) {
        const amt = (remainingF / 100).toFixed(2).replace('.', ',');
        textEl.textContent = `Cadeau 1 ✅ – nog maar ${amt} € tot gratis verzending!`;
      } else {
        textEl.textContent = 'Cadeau 1 ✅ – ga zo door!';
      }
      return;
    }

    // Noch nichts erreicht → nächstes Ziel je nach Konfiguration
    if (GIFT1_ENABLED && remainingG1 > 0) {
      const amt = (remainingG1 / 100).toFixed(2).replace('.', ',');
      textEl.textContent = `Nog ${amt} € tot je eerste cadeau! 🎁`;
      return;
    }

    if (FREE_ENABLED && remainingF > 0) {
      const amt = (remainingF / 100).toFixed(2).replace('.', ',');
      textEl.textContent = `Nog ${amt} € tot gratis verzending!`;
      return;
    }

    // Fallback
    textEl.textContent = 'Blijf shoppen en scoor voordelen ✨';

  } catch (e) {
    console.error('Free-shipping update failed', e);
  }
}

window.updateProgress = updateProgress;

/* ---------- Initialisierung ---------- */

function initFreeShipping() {
  // Sofort updaten
  updateProgress();

  // Cart-Change-Events → Cache invalidieren + updaten
  function onCartChange() {
    invalidateCartCache();
    updateProgress();
  }
  document.addEventListener('cart:updated', onCartChange);
  document.addEventListener('eurus:cart:items-changed', onCartChange);

  // ===== POLLING (bulletproof) =====
  // Prüft alle 400ms ob der Drawer sichtbar ist und der Text noch "…" zeigt.
  // Sobald beides zutrifft, wird updateProgress() aufgerufen.
  // Nutzt kaum Ressourcen (ein DOM-Check + String-Vergleich).
  setInterval(() => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    // Drawer sichtbar? (Alpine x-show entfernt display:none)
    const isVisible = drawer.offsetParent !== null || drawer.offsetHeight > 0;
    if (!isVisible) return;

    // Text noch Platzhalter?
    const textEl = document.getElementById('shipping-progress-text');
    if (textEl && (textEl.textContent === '…' || textEl.textContent === '\u2026' || textEl.textContent.trim() === '')) {
      updateProgress();
    }
  }, 400);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFreeShipping);
} else {
  initFreeShipping();
}
